import { Component, Injectable, OnInit, Input, Compiler, AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { BindComponentService } from '../../../../../app/utils/bind.component.service';
import { GroupService } from '../../../../../app/services/group.service';
import { AuthenticationService } from '../../../../../app/services/authentication.service';

import { AlertService } from '../../../../../app/utils/alert.service';
import { DataPackGroup } from '../../../../../app/models/dataPackGroup.model';
import { DataPackValue } from '../../../../../app/models/dataPackValue.model';
import { LoadingComponent } from '../../../../../app/home/paraEmpresas/modalLoading/content.component';
import { DataPackUserManagerModel } from '../../../../../app/models/data.manager.model';


  import * as _ from "lodash";
import { SaveConfirmationComponent } from './content.confirmation.component';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap/popover/popover';

/**
 * this.author Wesley Mascarenhas
 * @version $Id: content.component.ts 87748 2018-04-23 23:25:02Z thiago.h.neri $
 */
@Component({
  selector: 'saveConsume',
  templateUrl: './content.modal.template.html'
})
@Injectable()
export class SaveConsumeComponent implements OnInit{

  private static readonly DEFAULT_QUOTA_UNIT: string = 'GB';
  private static readonly DEFAULT_LIMIT_UNIT: string = 'MIN';
  private static readonly DEFAULT_LIMIT_CURENCY: string = 'R$';

  public form: FormGroup;
  public selectedUnit: any;
  public selectedUnit5G: any;

  public selectedLimitVoice: any;
  public saving: boolean;

  public quotaPattern: string = '^\\d+$|^\\d+\\.{1}[0-9]{1}$';// '\\d+(\\.[1-9]{1})?$';
  public limitPattern: string = '^\\d+$|^$';
  public overBalanceLimitPattern: string = '^\\d+$|^\\d+(,|\\.)\\d{1,2}$|^$';
  public overBalanceNextCicleLimitPattern: string = '^\\d+$|^\\d+(,|\\.)\\d{1,2}$|^$';
  public currencyPattern: string = '^(\d*)$';
  public limiteVoz: any;
  public isIlimitedGroup: boolean = false;
  public is5GRadioSelected: boolean = false;

  //'^(\d{1,15},\d{2}|U\$ ?\d{1,3}\.\d{2})$';

  @Input() mode: string;
  @Input() model: any;
  @Input() companyQuotaValue: string;
  @Input() isConsumedVoice: boolean;
  @Input() isCreateGroup: boolean;
  @Input() isData: boolean;
  @Input() isContextVoice: boolean;
  @Input() hasOverBalanceMonetaryVoice: boolean;
  @Input() hasHibridService: boolean;
  @Input() voiceFranchiseConsumptionContracted:any;

  public group: DataPackGroup = new DataPackGroup();

  constructor(private authenticationService: AuthenticationService,
              private modalService: NgbModal,
              private bindComponent: BindComponentService,
              private activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private groupService: GroupService,
              private alertService: AlertService) {
  }

  ngOnInit() {

    this.group = this.model.group;

     if (_.isNil(this.group.limit)) {
       this.group.limit = new DataPackValue();
       this.group.limit.value = '';
     }
     if (_.isNil(this.group.quota)) {
       this.group.quota = new DataPackValue();
       this.group.quota.value = '';
     }

     let editing: boolean = !_.isNil(this.group.id);
     let flagIlimitedGroup: boolean = this.checkIlimitedGroup(this.group);

     if (this.isCreateGroup && this.isOverBalanceMonetaryVoice()) { //&& this.isData
       this.form = this.formBuilder.group({
         name: [editing ? this.group.name : '', Validators.compose([Validators.required, Validators.maxLength(80)])],
         managerId: [editing && !_.isNil(this.group.manager) ? this.group.manager.id : ''],
         limitValue: [null, Validators.compose([Validators.pattern(this.limitPattern)])],
         quotaValue: [null, Validators.compose([Validators.required, Validators.pattern(this.quotaPattern)])],
         overBalanceLimitNextCycle: [null, Validators.compose([Validators.pattern(this.overBalanceNextCicleLimitPattern)])],
         managerLogin: [''],
         overBalanceLimit: [null, Validators.compose([Validators.pattern(this.overBalanceLimitPattern)])],
         technology: ['4G', Validators.required]
       });
       this.checkHasData();
     }else if (this.isCreateGroup && this.hasHibridService) { //&& this.isData
       this.form = this.formBuilder.group({
         name: [editing ? this.group.name : '', Validators.compose([Validators.required, Validators.maxLength(80)])],
         managerId: [editing && !_.isNil(this.group.manager) ? this.group.manager.id : ''],
         limitValue: [null, Validators.compose([Validators.pattern(this.limitPattern)])],
         quotaValue: ['', Validators.compose([Validators.required, Validators.pattern(this.quotaPattern)])],
         managerLogin: [''],
         overBalanceLimit: [null, Validators.compose([Validators.pattern(this.overBalanceLimitPattern)])],
         overBalanceAllCallsLimitNextCycle: [null, Validators.compose([Validators.pattern(this.limitPattern)])],
         technology: ['4G', Validators.required]
       });
       this.checkHasData();
     } else if (this.isCreateGroup && !this.isOverBalanceMonetaryVoice() && !this.hasHibridService ) { //&& this.isData
       this.form = this.formBuilder.group({
         name: [editing ? this.group.name : '', Validators.compose([Validators.required, Validators.maxLength(80)])],
         limitValue: [null, Validators.compose([Validators.pattern(this.limitPattern)])],
         overBalanceAllCallsLimitNextCycle: [null, Validators.compose([Validators.pattern(this.limitPattern)])],
         managerLogin: [''],
         overBalanceAllCallsLimit: [null, Validators.compose([Validators.pattern(this.limitPattern)])],
         quotaValue: [null, Validators.compose([Validators.required, Validators.pattern(this.quotaPattern)])],
         technology: ['4G', Validators.required]
       });
       this.checkHasData();
     } else if (this.isConsumedVoice && !this.isCreateGroup && this.isOverBalanceMonetaryVoice()) {
       //Edicao de Voz Monentário;
       this.form = this.formBuilder.group({
         name: [editing ? this.group.name : null, Validators.compose([Validators.required, Validators.maxLength(80)])],
         managerLogin: [editing && !_.isNil(this.group.manager) ? this.group.manager.login : ''],
         limitValue: [flagIlimitedGroup ? null : this.group.limit.value, Validators.compose([Validators.pattern(this.limitPattern)])],
         overBalanceLimit: [this.group.overBalanceLimit.value === '-----' ? null : this.group.overBalanceLimit.value , Validators.compose([Validators.pattern(this.overBalanceLimitPattern)])],
         overBalanceLimitNextCycle: [this.group.overBalanceLimitNextCycleControll.value === '-----' ? null : this.group.overBalanceLimitNextCycleControll.value, Validators.compose([Validators.pattern(this.overBalanceNextCicleLimitPattern)])],
       });
       this.checkSharedBalance();

     } else if (this.isConsumedVoice && !this.isCreateGroup && this.hasHibridService) {
       //Edicao de Voz Hibrido;
        this.form = this.formBuilder.group({
         name: [editing ? this.group.name : null, Validators.compose([Validators.required, Validators.maxLength(80)])],
         managerLogin: [editing && !_.isNil(this.group.manager) ? this.group.manager.login : ''],
         limitValue: [flagIlimitedGroup ? null : this.group.limit.value, Validators.compose([Validators.pattern(this.limitPattern)])],
         overBalanceLimit: [this.group.overBalanceLimit.value === '-----' ? null : this.group.overBalanceLimit.value, Validators.compose([Validators.pattern(this.overBalanceLimitPattern)])],
         overBalanceAllCallsLimitNextCycle: [this.group.overBalanceAllCallsLimitNextCycleControll.value === '-----' ? null : this.group.overBalanceAllCallsLimitNextCycleControll.value, Validators.compose([Validators.required, Validators.pattern(this.limitPattern)])],
       });
       this.checkSharedBalance();

     } else if (this.isConsumedVoice && !this.isCreateGroup && !this.isOverBalanceMonetaryVoice() && !this.hasHibridService ) {
       // Edicao de Voz Minuto;
       this.form = this.formBuilder.group({
         name: [editing ? this.group.name : null, Validators.compose([Validators.required, Validators.maxLength(80)])],
         managerLogin: [editing && !_.isNil(this.group.manager) ? this.group.manager.login : ''],
         limitValue: [flagIlimitedGroup ? null : this.group.limit.value],
         overBalanceAllCallsLimitNextCycle: [this.group.overBalanceAllCallsLimitNextCycleControll.value === '-----' ? null : this.group.overBalanceAllCallsLimitNextCycleControll.value, Validators.compose([Validators.required, Validators.pattern(this.limitPattern)])],
         overBalanceAllCallsLimit: [this.group.overBalanceAllCallsLimit.value === '-----' ? null : this.group.overBalanceAllCallsLimit.value, Validators.compose([Validators.pattern(this.limitPattern)])],
     });
       this.checkSharedBalance();

     } else if (!this.isConsumedVoice && !this.isCreateGroup) {
       this.form = this.formBuilder.group({
         name: [editing ? this.group.name : '', Validators.compose([Validators.required, Validators.maxLength(80)])],
         managerLogin: [editing && !_.isNil(this.group.manager) ? this.group.manager.login : ''],
         quotaValue: [editing ? this.group.quota.value : '', Validators.compose([Validators.required, Validators.pattern(this.quotaPattern)])],
         technology: [editing ? (this.group.technology || '4G') : '4G', Validators.required]
       });

     }

     this.setUnit();

     // Adiciona listener para mudança de tecnologia
     if (this.form.get('technology')) {
       this.form.get('technology').valueChanges.subscribe(value => {
         this.onTechnologyChange(value);
       });
     }
   }

  // Método chamado quando a tecnologia muda
  public onTechnologyChange(technology: string) {
    if (technology === '4G') {
      // Atualiza os valores para 4G
      this.updateSelectedUnit();

    } else if (technology === '5G') {
      // Atualiza os valores para 5G
      this.updateSelectedUnit();

    }
  }

  // Método para atualizar a unidade selecionada baseada na tecnologia
  private updateSelectedUnit() {
    const technology = this.form.get('technology').value;
    const quotaValue = this.form.get('quotaValue').value;

    if (technology === '4G') {
      let value = this.model.franchiseAvailableData && this.model.franchiseAvailableData[SaveConsumeComponent.DEFAULT_QUOTA_UNIT] ? this.model.franchiseAvailableData[SaveConsumeComponent.DEFAULT_QUOTA_UNIT] : '--';
      let limit: number = Number(value);
      this.is5GRadioSelected = false;
      if (this.model.group.quota) {
        limit = Number(value) + Number(this.model.group.quota.value);
      }

      if (quotaValue && !isNaN(Number(quotaValue))) {
        this.selectedUnit.value = (limit - Number(quotaValue)).toFixed(1);
      } else {
        this.selectedUnit.value = limit;
      }
    } else if (technology === '5G') {
      let value5G = this.model.franchiseAvailableData5G && this.model.franchiseAvailableData5G[SaveConsumeComponent.DEFAULT_QUOTA_UNIT] ? this.model.franchiseAvailableData5G[SaveConsumeComponent.DEFAULT_QUOTA_UNIT] : '--';
      let limit5G: number = Number(value5G);
       this.is5GRadioSelected = true;

      if (this.model.group.quota) {
        limit5G = Number(value5G) + Number(this.model.group.quota.value);
      }

      if (quotaValue && !isNaN(Number(quotaValue))) {
        this.selectedUnit5G.value = (limit5G - Number(quotaValue)).toFixed(1);
      } else {
        this.selectedUnit5G.value = limit5G;
      }
    }
  }

  private setUnit() {
    let value = this.model.franchiseAvailableData && this.model.franchiseAvailableData[SaveConsumeComponent.DEFAULT_QUOTA_UNIT] ? this.model.franchiseAvailableData[SaveConsumeComponent.DEFAULT_QUOTA_UNIT] : '--';
    let value5G = this.model.franchiseAvailableData5G && this.model.franchiseAvailableData5G[SaveConsumeComponent.DEFAULT_QUOTA_UNIT] ? this.model.franchiseAvailableData5G[SaveConsumeComponent.DEFAULT_QUOTA_UNIT] : '--';
    let limiteVoz = this.model.franchiseAvailableVoice && this.model.franchiseAvailableVoice[SaveConsumeComponent.DEFAULT_LIMIT_UNIT] ? this.model.franchiseAvailableVoice[SaveConsumeComponent.DEFAULT_LIMIT_UNIT] : '--';
    this.selectedLimitVoice = { 'unit': SaveConsumeComponent.DEFAULT_LIMIT_UNIT, 'value': limiteVoz };
    this.selectedUnit = { 'unit': SaveConsumeComponent.DEFAULT_QUOTA_UNIT, 'value': value };
    this.selectedUnit5G = { 'unit': SaveConsumeComponent.DEFAULT_QUOTA_UNIT, 'value': value5G };
    let data  = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
    this.isData = data['isData'];

    //console.log('value => ', value);
    //console.log('value 5G=> ', value5G);

  }

  public close() {
    this.activeModal.dismiss();
  }

  private openModalLoading() {
    this.modalService.open(LoadingComponent, { backdrop: 'static', keyboard: false, });
  }
  private save() {
    this.saving = true;
    let formValue = this.form.value;
    let payload: any = {};
    payload.isData = this.isData;
    payload.hasOverBalanceMonetaryVoice = this.hasOverBalanceMonetaryVoice;
    payload.hasHibridService = this.hasHibridService;
    if (!this.isCreateGroup) {
      payload.contextVoice = this.isContextVoice;
    }
    payload.id = this.model.group.id;
    payload.action = this.mode === 'creation' ? 'create' : 'edit';
    payload.name = formValue.name;
    payload.technology = formValue.technology; // Adiciona a tecnologia selecionada
    payload.quota = {
      value: formValue.quotaValue,
      dataPackValueType: SaveConsumeComponent.DEFAULT_QUOTA_UNIT
    };

    payload.is5GPortifolio = this.model.group.is5GPortifolio;
    payload.limit = {
      value:formValue.limitValue,
      dataPackValueType: SaveConsumeComponent.DEFAULT_LIMIT_UNIT
    };

    payload.overBalanceLimit = {
      value: formValue.overBalanceLimit,
      dataPackValueType: SaveConsumeComponent.DEFAULT_LIMIT_CURENCY
    };
      payload.overBalanceLimitNextCycleControll = {
      value:  formValue.overBalanceLimitNextCycle,
      dataPackValueType: SaveConsumeComponent.DEFAULT_LIMIT_CURENCY
    };
    payload.overBalanceLocalsLimit = {
      value: formValue.overBalanceLocalsLimit,
      dataPackValueType: SaveConsumeComponent.DEFAULT_LIMIT_UNIT
    };
    payload.overBalanceLocalsLimitNextCycleControll = {
      value: formValue.overBalanceLocalsLimitNextCycle,
      dataPackValueType: SaveConsumeComponent.DEFAULT_LIMIT_UNIT
    };
    payload.overBalanceAllCallsLimit = {
      value: formValue.overBalanceAllCallsLimit,
      dataPackValueType: SaveConsumeComponent.DEFAULT_LIMIT_UNIT
    };
    payload.overBalanceAllCallsLimitNextCycleControll = {
      value: formValue.overBalanceAllCallsLimitNextCycle,
      dataPackValueType: SaveConsumeComponent.DEFAULT_LIMIT_UNIT
    };
    payload.manager = {
        login: formValue.managerLogin,
      };
    this.saveGroup(payload);
  }

  public saveGroup(payload: any) {
    this.groupService.save(payload).subscribe(
      data => {
        this.activeModal.close();
        this.saving = false;
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.bindComponent.set(BindComponentService.LOADING_VOICE_CONSUMPTION, true);
        this.bindComponent.set(BindComponentService.LOADING_DATA_CONSUMPTION, true);
        this.bindComponent.set(BindComponentService.LOADING_DATA_CONSUMPTION_5G, true); 
        this.alertService.success(data['result']);
      },
      err => {
        this.bindComponent.set(BindComponentService.LOADING_VOICE_CONSUMPTION, false);
        this.saving = false;
        this.activeModal.close();
        this.bindComponent.set(BindComponentService.OPEN_MODAL_LOADING, false);
        this.alertService.error(err.result, err);
      }
    );
  }

  public openModalConfirmation(payload) {
    let modalRef = this.modalService.open(SaveConfirmationComponent, {
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.payload = payload;

  }

  private updateQuota() {
    if (this.form.controls['quotaValue'].value !=null && this.form.controls['quotaValue'].value.indexOf(',')) {
      this.form.controls['quotaValue'].setValue(this.form.controls['quotaValue'].value.replace(',', '.'));
    }

    const technology = this.form.get('technology').value;
    let value = this.model.franchiseAvailableData && this.model.franchiseAvailableData[SaveConsumeComponent.DEFAULT_QUOTA_UNIT] ? this.model.franchiseAvailableData[SaveConsumeComponent.DEFAULT_QUOTA_UNIT] : '--';
    let value5G = this.model.franchiseAvailableData5G && this.model.franchiseAvailableData5G[SaveConsumeComponent.DEFAULT_QUOTA_UNIT] ? this.model.franchiseAvailableData5G[SaveConsumeComponent.DEFAULT_QUOTA_UNIT] : '--';
    let limit: number = Number(value);
    let limit5G: number = Number(value5G);

    if (this.model.group.quota) {
       if (technology === '4G'){
          limit = Number(value) + Number(this.model.group.quota.value);
       } else {
          limit5G = Number(value5G) + Number(this.model.group.quota.value);
       }
    }
    let quotaConsume: number = 0;
    let quotaConsume5G: number = 0;
    if (this.model.group.quotaConsume) {
        if (technology === '4G'){
          quotaConsume = Number(this.model.group.quotaConsume.value);
       } else {
          quotaConsume5G = Number(this.model.group.quotaConsume.value);
       }
    }
    let allocateQuota: number = 0;
    let allocateQuota5G: number = 0;
    if (this.model.group.allocateQuota) {
       if (technology === '4G'){
          allocateQuota = Number(this.model.group.allocateQuota.value);
       } else {
          allocateQuota5G = Number(this.model.group.allocateQuota.value);
       }
    }

    let patt = new RegExp(this.quotaPattern);

    if (technology === '4G'){
      if (patt.test(this.form.controls['quotaValue'].value)) {
        if (this.form.controls['quotaValue'].value) {
          if (quotaConsume > Number(this.form.controls['quotaValue'].value)) {
            this.alertService.error('O valor da cota deve ser superior ao valor já consumido. Por favor reveja as configurações.',null);
            this.selectedUnit.value = limit;
            this.form.controls['quotaValue'].setErrors({ error: 'Invalid quota value' })
          } else if (allocateQuota > Number(this.form.controls['quotaValue'].value)) {
            this.alertService.error('O valor da cota deve ser superior ao valor já atribuído. Por favor reveja as configurações.',null);
            this.selectedUnit.value = limit;
            this.form.controls['quotaValue'].setErrors({ error: 'Invalid quota value' })
          } else if (limit < Number(this.form.controls['quotaValue'].value)) {
            this.alertService.error('A cota atribuída excede a franquia disponível para a empresa. Por favor reveja as configurações.',null);
            this.selectedUnit.value = limit;
            this.form.controls['quotaValue'].setErrors({ error: 'Invalid quota value' })
          } else {
            this.selectedUnit.value = (limit - Number(this.form.controls['quotaValue'].value)).toFixed(1);
          }
        }
      } else {
        this.selectedUnit.value = limit;
      }
    } else if (technology === '5G') {
      if (patt.test(this.form.controls['quotaValue'].value)) {
        if (this.form.controls['quotaValue'].value) {
          if (quotaConsume5G > Number(this.form.controls['quotaValue'].value)) {
            this.alertService.error('O valor da cota deve ser superior ao valor já consumido. Por favor reveja as configurações.',null);
            this.selectedUnit5G.value = limit5G;
            this.form.controls['quotaValue'].setErrors({ error: 'Invalid quota value' })
          } else if (allocateQuota5G > Number(this.form.controls['quotaValue'].value)) {
            this.alertService.error('O valor da cota deve ser superior ao valor já atribuído. Por favor reveja as configurações.',null);
            this.selectedUnit5G.value = limit5G;
            this.form.controls['quotaValue'].setErrors({ error: 'Invalid quota value' })
          } else if (limit5G < Number(this.form.controls['quotaValue'].value)) {
            this.alertService.error('A cota atribuída excede a franquia disponível para a empresa. Por favor reveja as configurações.',null);
            this.selectedUnit5G.value = limit5G;
            this.form.controls['quotaValue'].setErrors({ error: 'Invalid quota value' })
          } else {
            this.selectedUnit5G.value = (limit5G - Number(this.form.controls['quotaValue'].value)).toFixed(1);
          }
        }
      } else {
        this.selectedUnit5G.value = limit5G;
      }
    }

    // Atualiza a unidade selecionada após mudança na cota
    this.updateSelectedUnit();
  }

  public isConsumptionData() {
    return (this.isCreateGroup || (this.mode === 'edition' && !this.isConsumedVoice));
  }


  public isConsumptionVoice() {
    let condicao: boolean = this.isCreateGroup || (this.mode === 'edition' && this.isConsumedVoice)
    return condicao;
  }
  public isOverBalanceMonetaryVoice(){
    return this.hasOverBalanceMonetaryVoice;
  }
  private checkIlimitedGroup(group: any): boolean {
    this.isIlimitedGroup = ((this.isConsumedVoice) && ((null == group.limit) || (null == group.limit.value)) || (group.limit.value === '-----'));
    return this.isIlimitedGroup;
  }
  private checkLimit() {
    let patt = new RegExp(this.limitPattern);
    if ((patt.test(this.form.controls['limitValue'].value)) && (this.form.controls['limitValue'].value != '')) {

      if(this.isOverBalanceMonetaryVoice()){
        this.form.controls['overBalanceLimit'].enable();
        this.form.controls['overBalanceLimitNextCycle'].enable();
        this.form.controls['overBalanceLocalsLimit'].disable();
        this.form.controls['overBalanceLocalsLimit'].setValue('-----');
        this.form.controls['overBalanceLocalsLimitNextCycle'].disable();
        this.form.controls['overBalanceLocalsLimitNextCycle'].setValue('-----');

        this.form.controls['overBalanceAllCallsLimit'].disable();
        this.form.controls['overBalanceAllCallsLimit'].setValue('-----');
        this.form.controls['overBalanceAllCallsLimitNextCycle'].disable();
        this.form.controls['overBalanceAllCallsLimitNextCycle'].setValue('-----');

      }else{
        this.form.controls['overBalanceLocalsLimit'].enable();
        this.form.controls['overBalanceAllCallsLimit'].enable();

        this.form.controls['overBalanceLocalsLimitNextCycle'].enable();
        this.form.controls['overBalanceAllCallsLimitNextCycle'].enable();

        this.form.controls['overBalanceLimit'].disable();
        this.form.controls['overBalanceLimit'].setValue('-----');
        this.form.controls['overBalanceLimitNextCycle'].disable();
        this.form.controls['overBalanceLimitNextCycle'].setValue('-----');

      }

    } else {

      if(this.isOverBalanceMonetaryVoice()){
      this.form.controls['overBalanceLimit'].disable();
      this.form.controls['overBalanceLimit'].setValue('');
      this.form.controls['overBalanceLimitNextCycle'].disable();
      this.form.controls['overBalanceLimitNextCycle'].setValue('');
      }else{
        this.form.controls['overBalanceLocalsLimit'].disable();
      this.form.controls['overBalanceLocalsLimit'].setValue('');
      this.form.controls['overBalanceLocalsLimitNextCycle'].disable();
      this.form.controls['overBalanceLocalsLimitNextCycle'].setValue('');

      this.form.controls['overBalanceAllCallsLimit'].disable();
      this.form.controls['overBalanceAllCallsLimit'].setValue('');
      this.form.controls['overBalanceAllCallsLimitNextCycle'].disable();
      this.form.controls['overBalanceAllCallsLimitNextCycle'].setValue('');
      }

    }
  }

  private setEmptyValue(limitValue: string, overBalanceLimit: string): string {
    if ((null != limitValue) && (null != overBalanceLimit)) {
      if ((limitValue.toString() == '') && (overBalanceLimit.toString() == '')) {
        return null;
      } else {
        return this.commaToDot(overBalanceLimit);
      }
    }
    return null;
  }

  private setEmptyValueLimit(limitValue: string, overBalanceLimit: string): string {
    if ((null != limitValue) && (null != overBalanceLimit)) {
      if ((limitValue.toString() == '') && (overBalanceLimit.toString() == '')) {
        return null;
      } else {
        return limitValue;
      }
    }
    return null;
  }

  private setEmptyValueLimitLocalsAllCalls(limitValue: string, overBalanceLocalsLimit: string, overBalanceAllCallsLimit: string): string {
    if ((null != limitValue) && (null != overBalanceLocalsLimit)&& (null != overBalanceAllCallsLimit)) {
      if ((limitValue.toString() == '') && (overBalanceLocalsLimit.toString() == '') &&  (overBalanceAllCallsLimit.toString() == '')) {
        return null;
      } else {
        return limitValue;
      }
    }
    return null;
  }

  private checkSharedBalance() {
    let group: DataPackGroup = this.model.group;
    if (!group.isSharedBalance) {
      this.form.controls['limitValue'].disable();
    }
  }
  private checkHasData() {
    if (!this.isData) {
      this.form.controls['quotaValue'].disable();
    }
  }

  private commaToDot(value: string): string {
    if (null != value) {
      return ((value.indexOf(',') ? value.replace(',', '.') : value));
    }
    return '';
  }

  private updateLimit(){
    if (Number(this.form.controls['limitValue'].value) > Number(this.voiceFranchiseConsumptionContracted.value)) {
      this.alertService.error('O limite configurado para grupo excede o limite que está configurado para a empresa.',null);
      this.saving = true;
    }else{
      this.saving = false;
    }
  }

  public getTooltip(p : NgbPopover){
    let group: DataPackGroup = this.model.group;
    if(!group.isSharedBalance){
     return  'Grupo sem pacote de Saldo compartilhado';
    }else{
      p.close();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/home/paraEmpresas/consume/save/content.component.ts